import script from "./ParkingInfoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParkingInfoCard.vue?vue&type=script&setup=true&lang=ts"

import "./ParkingInfoCard.vue?vue&type=style&index=0&id=48c70c44&lang=scss&scoped=true"

import exportComponent from "/Users/alexandrelaurentidone/Code/flughafen-parkplatzrechner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c70c44"]])

export default __exports__